import { Link } from "react-router-dom";
import { categories } from "@/utils/catalog";
import type { MovieCategory } from "@/types/movie";

interface CategoryGridProps {
  counts: Record<string, number>;
}

export default function CategoryGrid({ counts }: CategoryGridProps) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {categories.map((item: MovieCategory, index) => (
        <Link
          key={item.slug}
          to={`/category/${item.slug}`}
          className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100/60 md:p-5"
        >
          <div className="flex items-center justify-between">
            <span
              className={`flex h-10 w-10 items-center justify-center rounded-lg ${
                index % 2 === 0
                  ? "bg-primary-100 text-primary-700"
                  : "bg-secondary-100 text-secondary-700"
              }`}
            >
              <i className={`${item.icon} text-xl`} />
            </span>
            <span className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500">
              {counts[item.slug] ?? 0} 部
            </span>
          </div>
          <h3 className="mt-3 font-heading text-base font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
            {item.name}
          </h3>
          <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {item.description}
          </p>
          <span className="mt-3 flex items-center gap-1 text-xs text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
            进入分类 <i className="ri-arrow-right-line" />
          </span>
        </Link>
      ))}
    </div>
  );
}